import { Component, Input } from '@angular/core';

/**
 * Declarative option for <app-custom-dropdown>.
 *
 * Usage:
 *   <app-custom-dropdown>
 *     <app-dropdown-option
 *       *ngFor="let item of items"
 *       [value]="item.id"
 *       [label]="item.name"
 *       [icon]="item.icon">
 *     </app-dropdown-option>
 *   </app-custom-dropdown>
 *
 * The component itself renders nothing — the parent reads its inputs
 * via @ContentChildren and builds the visible list.
 */
@Component({
  selector: 'app-dropdown-option',
  template: '',
})
export class DropdownOptionComponent {
  /** The value emitted when this option is selected. */
  @Input() value: any;

  /** The display text shown in the trigger and the panel. */
  @Input() label = '';

  /** Optional Font Awesome class string, e.g. 'fa fa-fw fa-calendar'. */
  @Input() icon: string | null = null;


}
